import Vue from 'vue';
import Ant from 'ant-design-vue';

const components = [
    Ant.message,
    Ant.Drawer,
    Ant.Spin,
    Ant.Select,
    Ant.Slider,
    Ant.Tooltip
]
Vue.prototype.$message =  Ant.message;
components.forEach(component => {
    Vue.use(component);
})


